function getDeliveryEstimation(deliveryDays, defaultEstimation) {
    if (!deliveryDays.length) {
        return defaultEstimation;
    }
    let slowest = [
        0,
        0
    ] // [value, index]
    ;
    deliveryDays.forEach((value, index)=>{
        // Strip out anything except numbers and -
        const cleanValue = value.replace(/[^\d-]/g, '');
        // If we have a bound value (like 1-3), take the first number.
        const days = Number(cleanValue.split('-')[0]);
        if (days > slowest[0]) {
            slowest = [
                days,
                index
            ];
        }
    });
    // Return the string representation.
    return deliveryDays[slowest[1]];
}

export { getDeliveryEstimation };
//# sourceMappingURL=get-delivery-estimation.js.map
